export default __webpack_public_path__ + "gantry-crane.png?30a4e23d7597f4f742eb4806cdc45fd7";